import { render, staticRenderFns } from "./merchantApplyInfo.vue?vue&type=template&id=5fc5b9ae&scoped=true"
import script from "./merchantApplyInfo.vue?vue&type=script&lang=js"
export * from "./merchantApplyInfo.vue?vue&type=script&lang=js"
import style0 from "./merchantApplyInfo.vue?vue&type=style&index=0&id=5fc5b9ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc5b9ae",
  null
  
)

export default component.exports